<template>
    <div class="pro_center">
        <div class="top">
            <div class="left">{{ $t('productCenter.title') }}</div>
            <!-- <div class="right">
                <div class="pro_item" :class="state.active===index?'text_color':''" v-for="(item, index) in state.proList" :key="index" @mouseover="mouseoverPro(index)">
                    {{ item.name }}
                    <div :class="state.active===index?'under_line':''"></div>
                </div>
            </div> -->
        </div>
        <div class="pro_con">
            <div class="left" data-aos="fade-right" data-aos-offset="500">
                <img src="@/assets/img/pro_1.png" alt="产品图片">
            </div>
            <div class="right" data-aos="fade-left" data-aos-offset="500">
                <div class="pro_name">
                    {{ $t('productCenter.featuredName') }}
                </div>
                <div class="pro_detail">
                    {{ $t('productCenter.featuredDesc') }}
                </div>
                <div class="pro_btn" @click="navigateTo(`/proDetail/${0}`)"> {{ $t('productCenter.viewDetail') }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive,onMounted } from "vue";
const { $aos } = useNuxtApp()
const state = reactive({
    active:0,
    proList:[
        {
            name:'睿长太肠癌检测',
            id:1
        },
        {
            name:'产品设备',
            id:2
        },
        {
            name:'在研产品',
            id:3
        },
        {
            name:'产品试剂',
            id:4
        },
        // {
        //     name:'透气细胞培养器',
        //     id:5
        // },
    ]
})
const mouseoverPro=(index)=>{
    state.active = index
}
onMounted(()=>{
  $aos().init({
    easing: 'ease-out-back',
    duration: 2000,
  })
})
</script>

<style lang="less" scoped>
.pro_center{
   .top{
    padding-top: 61px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    // margin: 0 -90px;
    .left{
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #333333;
    }
    .right{
        display: flex;
        margin-left: -30px;
        .pro_item{
            margin-left: 20px;
            color: #666666;
            cursor: pointer;
            .under_line{
            height: 2px;
            width: 100%;
            margin-top: 5px;
            background: linear-gradient(
                            to right,
                            rgba(0, 160, 233, 1),
                            rgba(255, 241, 0, 1)
                            );
        }
        }
        .text_color{
            color: rgba(0, 160, 233, 1);
        }
    }
   }
   .pro_con{
    display: flex;
    justify-content: space-evenly;
    padding-top: 30px;
    .left{
        img{
            width: 327px;
            height: 239px;
        }
    }
    .right{
        width: 40%;
        .pro_name{
            font-size: 8px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #333333;
            margin-bottom: 20px;
        }
        .pro_detail{
            // font-size: 8px;
            line-height: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
        }
        .pro_btn{
            width: 64px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            border: 1px solid #00A0E9;
            border-radius: 11px;
            color: #00A0E9;
            cursor: pointer;
            margin-top: 30px;
            transition: box-shadow 0.3s;
                &:hover {
                box-shadow: 0 0 4px rgba(45, 142, 228, 0.5);
            }
        }
    }
   }
}
</style>